import createList from '../../with-list';

import endpoints from '../../../../config/endpoints';

const namespace = 'bannersPublicationList';

const { actions, selectors, reducers } = createList({
	namespace,
	url: endpoints.BANNERS.PUBLICATIONS,
	perPage: 100
});

export { namespace, actions, selectors, reducers as default };


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/banners/publication/list/index.js